<script lang="ts" setup>
import { ref, computed } from 'vue'

/**
 * Props
 */
type Props = {
  src: string
  size?: string
  disabled?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  src: '',
  size: '20px',
  disabled: false,
})

/**
 * Refs
 */
const size = ref(props.size)

/**
 * Computed
 */
const src = computed(() => {
  return `url('${props.src}')`
})
</script>

<template>
  <i
    class="base-icon"
    :class="{ disabled: props.disabled }"
  />
</template>

<style lang="scss" scoped>
$--base-icon--size: v-bind(size);

.base-icon {
  position: relative;
  display: inline-block;
  min-width: $--base-icon--size;
  max-width: $--base-icon--size;
  height: 100%;
  height: $--base-icon--size;
  vertical-align: middle;

  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    content: '';
    background-image: v-bind(src);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transform: translateX(-50%) translateY(-50%);
  }

  &.disabled {
    opacity: 0.5;

    &::before {
      // #777777に近い色調整
      filter: grayscale(100%) brightness(0.93);
    }
  }
}
</style>
